import axios from "axios"
import "./interceptors/request";
import "./interceptors/response";
export default function initAxios(Vue) {
    axios.defaults.baseURL = '';//测试
    axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded';
    axios.defaults['transformRequest'] = data=>{
        if(typeof data!=="object")return data;
        let params=[];
        for(let key in data){
            if(data.hasOwnProperty(key)){
                params.push(key+"="+encodeURIComponent(data[key]))
            }
        }
        return params.join("&")
    };
    Vue.prototype.axios = Vue.prototype.$http = axios;
}
